module.exports = __webpack_public_path__ + "static/img/right-bg.cdcc2618.png";